import { IBase64, IJWT, Serializable } from '../../interfaces';

/**
 * Type guard for JSON Web Token.
 */
export function isJWT(value: string | IJWT): value is IJWT {
    const [ header, payload, signature ] = value.split('.');

    // TODO: That's not a real way to know if a string is a JSON Web Token.
    // We should decode the header and check the signature !
    return Boolean(header.length) &&
        Boolean(payload.length) &&
        Boolean(signature.length);
}

/**
 * Utils function to extract the encoded parts of a JSON Web Token.
 */
export function extractEncodedParts(token: IJWT): [ IBase64, IBase64, IBase64 ] {
    const [ header, payload, signature ] = token.split('.');

    return [
        header as IBase64,
        payload as IBase64,
        signature as IBase64,
    ];
}

/**
 * Utils function to decode the payload of a JSON Web Token.
 */
export function decodePayload(token: IJWT): Record<string, Serializable> {
    const [ , base64Url ] = extractEncodedParts(token);
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    try {
        const jsonPayload = decodeURIComponent(atob(base64).split('').map((char) => {
            return `%${ ('00' + char.charCodeAt(0).toString(16)).slice(-2) }`;
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch {
        throw new Error('Not a valid JWT');
    }
}
